import {GET_ALL_HIDDEN_PROPERTIES} from "../actions/types";

const initialState = {
    hiddenProperty: {
      docs: [],
      totalDocs: 0,
      limit: 0,
      page: 0,
      totalPages: 0,
      pagingCounter: 0,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
    loading: true,
    // propertyData: {},
  };

  const getHiddenPropertiesReducer=(state=initialState,{type,payload})=>{
    switch(type){
        case GET_ALL_HIDDEN_PROPERTIES:
            return {
                ...state,
                hiddenProperty:payload,
                loading:false,
            };
        default:
            return state;
    }
  }

  export default getHiddenPropertiesReducer;